import { render } from "./PaginatorInfo.vue?vue&type=template&id=53e4480f&ts=true"
import script from "./PaginatorInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginatorInfo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/core/report/components/PaginatorInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53e4480f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53e4480f', __exports__)) {
    console.log('reload')
    api.reload('53e4480f', __exports__)
  }
  
  module.hot.accept("./PaginatorInfo.vue?vue&type=template&id=53e4480f&ts=true", () => {
    console.log('re-render')
    api.rerender('53e4480f', render)
  })

}


export default __exports__